import { render, staticRenderFns } from "./CustomFormHiddenElement.vue?vue&type=template&id=366a5aa6"
import script from "./CustomFormHiddenElement.vue?vue&type=script&lang=js"
export * from "./CustomFormHiddenElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports